import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { exportToYaml } from "../../../abstract/controller/modelYamlExport";
import { importFromYaml } from "../../../abstract/controller/modelYamlImport";
import * as systemUtils from "../../../abstract/controller/utils/systemUtils";
import { setSpinner, setSpinnerMessage } from "../../../abstract/redux/slice/overlaySlice";
import { getRoot, setRoot } from "../../../abstract/redux/slice/structureSlice";
import { ButtonDefault } from "../../ui/buttons/ButtonDefault";
import styles from "./AsideElementOptions.module.scss";

function AsideElementOptions() {
  const _dispatch = useDispatch();

  const _root = useSelector(getRoot);

  const _fileRef = useRef(null);

  const handleFileChange = async (event) => {
    const _file = event.target.files && event.target.files[0];

    if (!_file) {
      return;
    }

    _dispatch(setSpinner(true));
    _dispatch(setSpinnerMessage("loading"));

    const _content = await systemUtils.readTextFromFile(_file);
    const { model: _results, error: _error } = importFromYaml(_content);

    if (!_results) {
      console.log(`The file could not be imported! ${_error}`);
    } else {
      _dispatch(setRoot(_results, 0));
      _dispatch(setSpinner(false));
    }

    event.target.value = null;
  };

  const handleImport = () => {
    _fileRef.current.click();
  };

  const handleExport = () => {
    systemUtils.downloadFile(exportToYaml(_root), "model.yaml");
  };

  return (
    <div className={styles["options"]}>
      <input
        style={{ display: "none" }}
        ref={_fileRef}
        type="file"
        accept=".yaml"
        onChange={handleFileChange}
      />
      <ButtonDefault text={"upload model"} handler={handleImport} shadow={false} wide />
      <ButtonDefault text={"export model"} handler={handleExport} shadow={false} wide />
    </div>
  );
}

export default AsideElementOptions;
